import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

export interface Plan {
  price_id: string;
  id: string;
  name: string;
  currency: string;
  amount: number;
  interval: string;
  trial_period_days?: number; // Made optional since it's commented out
  description: string;
  benefits: string[];
}

export interface PlansResponse {
  plans: Plan[];
}

export interface SubscriptionRequest {
  price_id: string;
}

export interface SubscriptionStatus {
  data: {
    system: {
      id: number;
      uuid: string;
      user_uid: string;
      org_uuid: string;
      stripe_status: string;
      stripe_subscription_id: string;
      quantity: number;
      stripe_customer_id: string;
      stripe_price: string;
      stripe_created_at: string;
      stripe_current_period_start_at: string;
      stripe_current_period_end_at: string;
      stripe_cancel_at: string | null;
      trial_start_at: string;
      trial_end_at: string;
      trial_status: string | null;
      created_at: string;
      updated_at: string;
      stripe_final_plan_amount: number;
    };
  };
  code: number;
  message: string;
  success: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

   constructor(private httpClient: HttpClient) { }
   
   getCustomerPricingTableCheckoutSession(org_uuid: string): Observable<any> {
    const url = `${environment.apiUrlV1}organizations/${org_uuid}/stripe/create-checkout-session-pricing-table`;
    return this.httpClient.get(`${url}`);
  }

  getSubscriptionActive(org_uuid: string): Observable<SubscriptionStatus> {
    const url = `${environment.apiUrlV1}organizations/${org_uuid}/stripe/status`;
    return this.httpClient.get<SubscriptionStatus>(url);
  }

  getCustomerPortalLink(org_uuid: string): Observable<any> {
    const url = `${environment.apiUrlV1}organizations/${org_uuid}/stripe/customer-portal`;
    return this.httpClient.get(`${url}`);
  }

  // stripe/fulfill-checkout-session
  fulfillCheckoutSession(session_id: string): Observable<any> {
    const url = `${environment.apiUrlV1}stripe/fulfill-checkout-session`;
    return this.httpClient.post(`${url}`, { session_id });
  }

  getUpcomingInvoice(org_uuid: string): Observable<any> {
    const url = `${environment.apiUrlV1}organizations/${org_uuid}/stripe/upcoming-invoice`;
    return this.httpClient.get(`${url}`);
  }

  // Get available plans for an organization
  getPlans(org_uuid: string): Observable<any> {
    const url = `${environment.apiUrlV1}organizations/${org_uuid}/stripe/plans`;
    return this.httpClient.get<any>(url);
  }

  // Create a new subscription
  createSubscription(org_uuid: string, price_id: string): Observable<any> {
    const url = `${environment.apiUrlV1}organizations/${org_uuid}/stripe/subscriptions`;
    const payload: SubscriptionRequest = { price_id };
    return this.httpClient.post(url, payload);
  }
    
}
